export default __webpack_public_path__ + "static/media/twitter-dark.300ae854.svg";